<template>
  <!--  <img src="https://img.alicdn.com/imgextra/i2/O1CN01DhnOzu1KcJf4M74Eo_!!6000000001184-0-tps-1470-700.jpg" style="width: 100%">-->
  <div style="text-align: center;">
    <div class="mt-3">
      <div class="container">
        <img
          src="https://img.alicdn.com/imgextra/i3/O1CN01ZBe8Zq28rBJqCzLZV_!!6000000007985-0-tps-600-1000.jpg"
          style="width: 100%;height:100%;"
        />
        <router-link to="/m/merchant/383">
          <div
            class="btn kokoWebButtons mt-2"
            style="background-color: #000000; width: 145px;position: absolute;top: 84%; left: 25%;transform: translate(-50%, -50%); -ms-transform: translate(-50%, -50%);"
          >
            <span style="color: #ffffff; font-size: 14px; font-weight: bold"
              >Shop Now</span
            >
          </div>
        </router-link>
      </div>
      <!-- <div class="container">
        <div class="sectionHead">Exclusive Deals from Hamedia</div>
        <div class="sectionBody">
          Enjoy up to 30% Discount from Culture by ARI. Tap on the box to view your Discount.
        </div>
      
        <div class="body_section" style="margin-top:5%;">
          <div class="row">
            <div class="col-12">
              <div class="present" id="present" style="margin-top:20%;">
                <div class="lid">
                  <span></span>
                </div>
                <div class="promo">
                  <img
                    src="https://img.alicdn.com/imgextra/i2/O1CN01rpZPMi1IJsUqEABg7_!!6000000000873-0-tps-1400-700.jpg"
                    style="width: 59%; padding-right: 5px; padding-left: 5px;"
                  />
                  <p>20% off promo</p>
                  <h2>ILOVEYOU</h2>
                </div>
                <div class="box">
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
            <div class="col-6 text-center" style="display:none;">
              <div class="present" id="present">
                <div class="lid">
                  <span></span>
                </div>
                <div class="promo">
                  <MerRectDealBannerMob id="328" />
                  <p>20% off promo</p>
                  <h2>ILOVEYOU</h2>
                </div>
                <div class="box">
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div> 
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "axios";

// Interop vue 2 component to vue 3
import toVue3 from "vue-2-3/to-vue-3";
import Vue2 from "vue2";
import * as Vue3 from "vue";
// import MerRectDisp from "@/components/MerRectDisp";

toVue3.register(Vue2, Vue3);

const api = "https://devapi.paykoko.com/backend/merchantcat";

// import MerRectDealBannerMob from "../components/MerRectDealBannerMob";

export default {
  name: "MobPromotionView",
  data() {
    return {
      finalId: 0,
      cattype: "deals",
    };
  },
  created() {
    document.title = "Deals @ Koko";
  },
  mounted() {
    // const present = document.getElementById("present");
    // const options = {
    //   colors: [
    //     "#34D963",
    //     "#068C2C",
    //     "#FF5757",
    //     "#8C1414",
    //     "#D9D74A",
    //     "#1E91D9",
    //     "#1B608C",
    //   ],
    // };
    // present.addEventListener("mouseenter", () => {
    //   confetti(options);
    // });
    // present.addEventListener("touchstart", () => {
    //   confetti(options);
    // });
  },
  setup() {
    const page = ref(1);
    const list = ref([]);
    let dataId = 0;
    // let docArray = new Map([])

    const infiniteHandler = async ($state) => {
      const { data } = await axios.post(
        api,
        '{"Page": ' + dataId + ',"CategoryName":"deals"}'
      );
      // console.log(docArray[0].merchantName)
      // " + +
      // console.log(this.data().finalId)
      // let test=JSON.parse(list.value);
      // console.log("Woah"+test)
      // console.log(test)
      // console.log(data)
      // list.value.values().

      if (data) {
        page.value += 1;
        list.value.push(...data);
        dataId = data[data.length - 1].id;
        $state.loaded();
      } else {
        console.log("End of the line");
        $state.complete();
      }
    };
    return {
      infiniteHandler,
      slots: {
        noMore: "Test",
      },
      list,
    };
  },
};
</script>

<style scoped>
.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
  text-align: center;
}

.faqHeader {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.faqText {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  text-align: left;
  /* line-height: 42px; */
  margin-top: 20px;

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

.kokoWebButtons {
  background-color: #022078;
  border: 0;
  height: 50px;
  width: 100%;
  font-weight: bolder;
}

.playicon {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

.stepperBody {
  font-size: 16px;
}

/* Snow Animation */

/* customizable snowflake styling */
.snowflake {
  color: #ffffff;
  font-size: 1.2em;
  font-family: Arial;
  text-shadow: 0 0 1px rgb(206, 206, 206);
}

@-webkit-keyframes snowflakes-fall {
  0% {
    top: -10%;
  }
  100% {
    top: 100%;
  }
}
@-webkit-keyframes snowflakes-shake {
  0% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
  50% {
    -webkit-transform: translateX(80px);
    transform: translateX(80px);
  }
  100% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
}
@keyframes snowflakes-fall {
  0% {
    top: -10%;
  }
  100% {
    top: 100%;
  }
}
@keyframes snowflakes-shake {
  0% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(80px);
  }
  100% {
    transform: translateX(0px);
  }
}
.snowflake {
  position: fixed;
  top: -10%;
  z-index: 9999;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
  -webkit-animation-name: snowflakes-fall, snowflakes-shake;
  -webkit-animation-duration: 10s, 3s;
  -webkit-animation-timing-function: linear, ease-in-out;
  -webkit-animation-iteration-count: infinite, infinite;
  -webkit-animation-play-state: running, running;
  animation-name: snowflakes-fall, snowflakes-shake;
  animation-duration: 10s, 3s;
  animation-timing-function: linear, ease-in-out;
  animation-iteration-count: infinite, infinite;
  animation-play-state: running, running;
}
.snowflake:nth-of-type(0) {
  left: 1%;
  -webkit-animation-delay: 0s, 0s;
  animation-delay: 0s, 0s;
}
.snowflake:nth-of-type(1) {
  left: 10%;
  -webkit-animation-delay: 1s, 1s;
  animation-delay: 1s, 1s;
}
.snowflake:nth-of-type(2) {
  left: 20%;
  -webkit-animation-delay: 6s, 0.5s;
  animation-delay: 6s, 0.5s;
}
.snowflake:nth-of-type(3) {
  left: 30%;
  -webkit-animation-delay: 4s, 2s;
  animation-delay: 4s, 2s;
}
.snowflake:nth-of-type(4) {
  left: 40%;
  -webkit-animation-delay: 2s, 2s;
  animation-delay: 2s, 2s;
}
.snowflake:nth-of-type(5) {
  left: 50%;
  -webkit-animation-delay: 8s, 3s;
  animation-delay: 8s, 3s;
}
.snowflake:nth-of-type(6) {
  left: 60%;
  -webkit-animation-delay: 6s, 2s;
  animation-delay: 6s, 2s;
}
.snowflake:nth-of-type(7) {
  left: 70%;
  -webkit-animation-delay: 2.5s, 1s;
  animation-delay: 2.5s, 1s;
}
.snowflake:nth-of-type(8) {
  left: 80%;
  -webkit-animation-delay: 1s, 0s;
  animation-delay: 1s, 0s;
}
.snowflake:nth-of-type(9) {
  left: 90%;
  -webkit-animation-delay: 3s, 1.5s;
  animation-delay: 3s, 1.5s;
}
/* Demo Purpose Only*/
.demo {
  font-family: "Raleway", sans-serif;
  color: #fff;
  display: block;
  margin: 0 auto;
  padding: 15px 0;
  text-align: center;
}
.demo a {
  font-family: "Raleway", sans-serif;
  color: #000;
}

/* Gift box animation */

.present {
  margin-top: 30%;
  width: 410px;
  max-width: 90vw;
  margin: 0 auto;
  cursor: pointer;
}

.box {
  width: 350px;
  max-width: 50vw;
  height: 175px;
}

.box,
.lid {
  background: radial-gradient(white 15%, transparent 15.1%),
    radial-gradient(white 15%, transparent 15.1%), rgb(240, 58, 58);
  background-position: 0 0, 25px 25px;
  background-size: 50px 50px;
  position: relative;
  margin: 0 auto;
}

.lid {
  width: 400px;
  max-width: 50vw;
  height: 30px;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 0 2px;
  background-color: rgb(216, 52, 52);
  top: 0;
  left: 0;
  transition: top ease-out 0.5s, left ease-out 0.5s, transform ease-out 0.5s;
}

.box span,
.lid span {
  position: absolute;
  display: block;
  background: rgba(235, 199, 0, 0.8);
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.1);
}

.box span:first-child {
  width: 100%;
  height: 30px;
  top: 65px;
}

.box span:last-child,
.lid span {
  width: 30px;
  height: 100%;
  left: 50px;
}

.promo {
  font-size: 30px;
  color: white;
  text-align: center;
  position: relative;
  height: 0;
  top: 10px;
  transition: all ease-out 0.7s;
}

.promo p {
  font-size: 24px;
  margin: 0;
}

.promo h2 {
  font-size: 40px;
  margin: 0;
}

.present:hover .lid {
  top: -100px;
  transform: rotateZ(10deg);
  left: 10px;
}

.present:hover .promo {
  top: -90px;
}
</style>
